import { Heading, Stack } from '@global-ecom/nitro-uds/elements';
import { useCallback, useEffect, useState } from 'react';

import { Styles } from 'ui/components/Styles';
import { useTranslate } from 'hooks/useTranslations';
import { Skeleton } from 'ui/components/Skeleton';
import { getSizesFromSizeGroups } from 'utils/products';
import { Variant } from '__generated__/graphql';
import { usePageEventsContext } from 'hooks/usePageEventsContext';
import { event, AnalyticsEvents } from 'utils/analytics';

export const GWPNew_ColorPicker = ({
  variations,
  selectedVariant,
  setSelectedVariant,
  productName,
  productId,
}: {
  variations: Variant[];
  selectedVariant: Variant;
  setSelectedVariant: (selectedVariant: Variant) => void;
  productName: string;
  productId: string;
}) => {
  const translate = useTranslate();

  const [desiredSwatch, setDesiredSwatch] = useState<string>();

  useEffect(() => {
    // when product is changed -> set the swatch of the first selectedVariant
    setDesiredSwatch(variations[0].id.split('_')[1]);
  }, [variations]);

  const sizes = selectedVariant
    ? getSizesFromSizeGroups(selectedVariant.sizeGroups)
    : [];
  const { pageviewEventHasFired } = usePageEventsContext();

  const onChangeStyle = useCallback(
    swatch => {
      setDesiredSwatch(swatch);
      const desiredVariant = variations.find(
        v => v.id.split('_')[1] === swatch
      );
      if (desiredVariant) {
        setSelectedVariant(desiredVariant);
        if (pageviewEventHasFired) {
          event(AnalyticsEvents.GA4_CustomEvent, {
            event_name: AnalyticsEvents.CHANGE_COLOR,
            event_params: {
              item_id_ep: desiredVariant?.id,
              item_name_ep: productName,
              color_code_ep: `a${desiredVariant?.colorValue}`,
              style_number_ep: productId,
              is_gift: 'true',
            },
          });
        }
      }
    },
    [
      pageviewEventHasFired,
      productId,
      productName,
      setSelectedVariant,
      variations,
    ]
  );

  return (
    <>
      <Stack gap="xs">
        <Heading asChild size="sm" weight="bold">
          <h3>{translate('color')}</h3>
        </Heading>
        {selectedVariant?.colorName ? (
          <Heading asChild size="xxxs" weight="normal">
            <h4>
              {selectedVariant?.colorName}{' '}
              {!selectedVariant.orderable && (
                <span className="sr-only">
                  :{' '}
                  {selectedVariant?.displayOutOfStock?.displayValue ||
                    translate('soldOut')}
                </span>
              )}
            </h4>
          </Heading>
        ) : (
          <Skeleton className="mt-2 w-24 h-4" />
        )}
      </Stack>
      <Styles
        desiredSwatch={desiredSwatch}
        onChange={onChangeStyle}
        variations={variations}
        isHydrating={sizes.length === 0}
      />
    </>
  );
};
